export default "__VITE_ASSET__BTfbwljH__"